import {
  ALL_FILTER_VALUE,
  RegionalOverviewFilterType,
  buildFilter,
  type Filter
} from '@features/regional-overview/regional-overview.models';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';
import { isAllOrEmpty } from './builders.utils';

export const buildZonesFilter = (): Filter =>
  buildFilter<RegionalOverviewProperties>({
    type: RegionalOverviewFilterType.ZONES,
    defaultValue: [ALL_FILTER_VALUE],
    includeAllOption: true,
    translatable: false,
    getValues: feature => {
      const zone = feature.properties?.field_zone;
      return zone ? [zone] : [];
    },
    matches: (feature, value) => {
      if (isAllOrEmpty(value)) return true;
      const zone = feature.properties?.field_zone;
      if (!zone) return false;
      return (value as string[]).includes(zone);
    }
  });
